import { ConditionEqualityType, type ConditionDescriptor } from "../../../../../api/types/fieldConfigurationTypes";
import type { ActiveFilter } from "../../dashboard.types";
import { toFilterValue } from "./filterValuesQuery";
import type { FilterWidgetSummary } from "./parentFilterOptions";

export const createParentCondition = (
  dimensionName: string,
  parentValues: unknown[]
): ConditionDescriptor | undefined => {
  const values = parentValues.map(toFilterValue);
  if (values.length === 0) {
    return undefined;
  }

  return { filter: { dimensionName, equalityType: ConditionEqualityType.Equal, values }, conditions: [] };
};

export const getParentCondition = (
  filterWidgets: FilterWidgetSummary[],
  activeFilters: ActiveFilter[],
  widgetId: string
): ConditionDescriptor | undefined => {
  const widget = filterWidgets.find((w) => w.widgetId === widgetId);
  if (!widget?.parentWidgetId) {
    return undefined;
  }

  const parent = filterWidgets.find((w) => w.widgetId === widget.parentWidgetId);
  if (parent?.dashboardFilterId === undefined) {
    return undefined;
  }

  const parentSelection = activeFilters.find(
    (f) => f.widgetId === parent.widgetId && f.id === parent.dashboardFilterId
  );
  return createParentCondition(parent.dashboardFilterId, parentSelection?.values ?? []);
};
